export const ColorIndex = [
  '#1A90FE',
  '#0240A0',
  '#06BAD1',
  '#822B9D',
  '#D0D004',
  '#666F25',
  '#FE5448',
  '#8A0002',
  '#DF8FE2',
  '#CB7300',
];
